import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class Following extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", 
                /* tslint:disable-next-line */
                d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.5 11.5332L12.7637 5.26367L12.2363 4.73633L6.5 10.4668L3.76367 7.73633L3.23633 8.26367L6.5 11.5332Z" })));
    }
}
